export const findGetParameter = (search) => {
  let queryDict = {};
  search
    .substr(1)
    .split('&')
    .forEach(function (item) {
      queryDict[item.split('=')[0]] = item.split('=')[1];
    });

  return queryDict;
};
